/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Type_BusinessInputs */

const en_queue_type_business = /** @type {(inputs: Queue_Type_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Object`)
};

const de_queue_type_business = /** @type {(inputs: Queue_Type_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Objekt`)
};

/**
* | output |
* | --- |
* | "Business Object" |
*
* @param {Queue_Type_BusinessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const queue_type_business = /** @type {((inputs?: Queue_Type_BusinessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Type_BusinessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_queue_type_business(inputs)
	return de_queue_type_business(inputs)
});